import { render, staticRenderFns } from "./NhstValidateCodeAndChangePassword.vue?vue&type=template&id=736420c4"
import script from "./NhstValidateCodeAndChangePassword.vue?vue&type=script&lang=js"
export * from "./NhstValidateCodeAndChangePassword.vue?vue&type=script&lang=js"
import style0 from "./NhstValidateCodeAndChangePassword.vue?vue&type=style&index=0&id=736420c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports